/**
 * 桌面端产品形态。构建时由 Vite mode 注入 `VITE_DESKTOP_EDITION`。
 *
 * - `web`   : 浏览器 / docker desktop-web(相对 /api/v1)
 * - `local` : 单机 Tauri(本机 sidecar + 内嵌 PG + 桌面授权门)
 * - `saas`  : 云版瘦客户端 Tauri(只连 https://api.vip0101.com,无 sidecar)
 *
 * 发安装包时两套产物必须分开,见 README「云版 vs 单机版」。
 */
export type DesktopEdition = 'web' | 'local' | 'saas'

export function desktopEdition(): DesktopEdition {
  const e = import.meta.env.VITE_DESKTOP_EDITION
  if (e === 'saas' || e === 'local') return e
  return 'web'
}

/** 云版瘦客户端(连公网 API,不做本地授权/本地 AI key)。 */
export function isSaasDesktop(): boolean {
  return desktopEdition() === 'saas'
}

/** 单机版 Tauri(本机 sidecar)。 */
export function isLocalDesktop(): boolean {
  return desktopEdition() === 'local'
}
